import type { AnyBlockConfigOnComponentOptions } from './api/config';
import { callOrReturn } from '#layers/base/public';
import { getBlockConfig } from './api/config';
import { resolveBuiltinBlock } from './resolve';

/**
 * Recommended display block ids declared by a block config's field binding, resolved against the
 * field's type options. Shared by the appearance editor (which already holds the input config) and
 * the render-time display resolver so both agree on which display follows a given input.
 */
export function getRecommendedDisplayIdsFromConfig(
	config: AnyBlockConfigOnComponentOptions | null | undefined,
	context: { typeOptions?: Record<string, unknown> } = {},
): string[] {
	return callOrReturn(config?.fieldBinding?.recommendedDisplays, context) ?? [];
}

/** As {@link getRecommendedDisplayIdsFromConfig}, resolving the config from a builtin block id. */
export function getBlockRecommendedDisplayIds(
	blockId: string | null | undefined,
	context: { typeOptions?: Record<string, unknown> } = {},
): string[] {
	if (!blockId) return [];

	const block = resolveBuiltinBlock(blockId);
	if (!block) return [];

	return getRecommendedDisplayIdsFromConfig(getBlockConfig(block), context);
}
